exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin_top[data-v-00fa2d58] {\r\n  margin-bottom: 20px;\n}\r\n", ""]);

// exports
